import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Link,
  useNavigate,
  useOutletContext,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Constants from "../../../data/Constants";
import { getCounsellingSessions } from "../../../services/mentor.service";
import { useConfirm } from "material-ui-confirm";
import CounsellingDetailsDialog from "../../../components/CounsellingDetailsDialog";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";

import { Button } from "@mui/material";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

const customHeaderStyle = (params) => {
  return <b>{params.colDef.headerName}</b>;
};

function CounsellingSessions(props) {
  const [counsellingDialog, setCounsellingDialog] = useState({
    status: false,
    data: false,
  });

  const columns = [
    {
      field: "_id",
      width: 200,
      headerName: "Session ID",
      renderHeader: customHeaderStyle,
    },

    {
      field: "mentor",
      headerName: "Mentor",
      width: 200,
      renderHeader: customHeaderStyle,
      renderCell: (params) => (
        <Link
          to={"/dashboard/mentors/" + params.value._id}
          className="hover:underline"
        >
          {params.value.firstname
            ? params.value.firstname + " " + params.value.lastname
            : "Unknown"}
        </Link>
      ),
    },

    {
      field: "slot",
      width: 300,
      headerName: "Time",
      type: "date",
      renderHeader: customHeaderStyle,
      valueFormatter: (params) => {
        return params.value
          ? moment(params.value.time).format(Constants.DATE_TIME_FORMAT)
          : "-";
      },
    },

    {
      field: "duration",
      width: 150,
      headerName: "Duration",
      type: "date",
      renderHeader: customHeaderStyle,
      renderCell: (params) => {
        return params.row.slot?.duration + " mins";
      },
    },

    {
      field: "isCancelled",
      width: 150,
      headerName: "Cancelled",
      renderHeader: customHeaderStyle,
    },

    {
      field: "student",
      headerName: "Student",
      width: 200,
      renderHeader: customHeaderStyle,
      renderCell: (params) => (
        <Link
          to={"/dashboard/students/" + params.value._id}
          className="hover:underline"
        >
          {params.value.firstname
            ? params.value.firstname + " " + params.value.lastname
            : "Unknown"}
        </Link>
      ),
    },

    {
      field: "aim",
      width: 250,
      headerName: "Aim",
      renderHeader: customHeaderStyle,
    },

    {
      field: "action",
      width: 250,
      headerName: "Actions",
      renderHeader: customHeaderStyle,
      renderCell: (params) => {
        // console.log(params);
        return (
          <div>
            <Button
              variant="contained"
              onClick={() => {
                setCounsellingDialog({
                  status: true,
                  data: params.row,
                });
              }}
            >
              More
            </Button>
          </div>
        );
      },
    },
  ];

  const confirm = useConfirm();
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const mentor = searchParams.get("mentor");

  const { setProgress, setToast, isRefreshed } = useOutletContext();

  useEffect(() => {
    async function api() {
      try {
        setProgress(true);
        const filters = {};
        if (mentor) {
          filters.mentor = mentor;
        }
        const res = await getCounsellingSessions(filters);
        if (res) {
          setData(res);
          setProgress(false);
        } else {
          // error
          setToast({ error: true, message: Constants.Error.UNKNOWN });
          setProgress(false);
        }
      } catch (error) {
        // error
        console.log(error);
        setToast({ error: true, message: Constants.Error.UNKNOWN });
        setProgress(false);
      }
    }

    api();
  }, [isRefreshed]);

  return (
    data && (
      <div>
        {mentor && data && (
          <h1 className="text-sm my-4">
            Showing Results for :{" "}
            <b>
              {data[0] && data[0].mentor.firstname
                ? data[0].mentor.firstname + " " + data[0].mentor.lastname
                : mentor}
            </b>
          </h1>
        )}

        <div className="flex h-full w-full">
          <div className="w-full overflow-scroll " style={{ height: "80vh" }}>
            <DataGrid
              rows={data ?? []}
              columns={columns}
              getRowId={(row) => row._id}
              autoPageSize
              components={{
                Toolbar: CustomToolbar,
              }}
            />
            <CounsellingDetailsDialog
              open={counsellingDialog.status}
              counselling={counsellingDialog.data}
              onClose={() => {
                setCounsellingDialog({ status: false, data: false });
              }}
            />
          </div>
        </div>
      </div>
    )
  );
}

export default CounsellingSessions;
